{
  "account": {
    "id": "ID",
    "stringId": "String ID",
    "custodianAccountNumber": "Custodian Number",
    "custodianAccountName": "Custodian Name",
    "type": "Type",
    "translatedAccountType": "Translated Type",
    "state": "State",
    "lastUpdatedBy": "Last Updated By",
    "applyForGovFunds": "Apply For Gov Funds",
    "sourceOfFunds": "Source Of Funds",
    "forceOpen": "Force Open",
    "jurisdiction": "Jurisdiction",
    "feePaymentAccount": "Fee Payment Account",
    "taxRank": "Tax Rank",
    "defaultTaxRank": "Default Tax Rank",
    "requiresFeeRedirectionSigned": "Requires Fee Redirection Signed",
    "feeRedirectionSignedAt": "Fee Redirection Signed At",
    "overrideTaxRank": "Override Tax Rank",
    "baseCurrency": "Base Currency",
    "availableCurrencies": "Available Currencies",
    "translatedNickName": "Translated Nick Name",
    "custodianSortingOrderPriority": "Custodian Sorting Order Priority",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "activatedAt": "Activated At",
    "dealerCode": "Dealer Code",
    "dealerName": "Dealer Name",
    "dealerAccountNumber": "Dealer Account Number",
    "groupEmployer": "Group Employer",
    "groupNumber": "Group Number",
    "sourceType": "Source Type",
    "externalSourceType": "External Source Type",
    "eligibleForDisabilityTaxCredit": "Eligible For Disability Tax Credit",
    "rightOfSurvivorship": "Right Of Survivorship",
    "respAllBeneficiariesAreInBc": "RESP All Beneficiaries Are In BC",
    "user": "User",
    "organization": "Organization",
    "householdClientGroup": "Household",
    "repCode": "Rep Code",
    "transactionsTotal": "Transactions Total",
    "program": "Program",
    "feeTier": "Fee Tier",
    "applicableFeeTier": "Applicable Fee Tier",
    "billingSchedule": "Billing Schedule",
    "applicableBillingSchedule": "Applicable Billing Schedule",
    "statistics": "Statistics",
    "scheduledIncomeFundTransfer": "Scheduled Income Fund Transfer",
    "custodianConnection": "Custodian Connection"
  },
  "subAccount": {
    "id": "ID",
    "name": "Name",
    "state": "State",
    "suitabilityScore": "Suitability Score",
    "calculatedSuitabilityScore": "Calculated Suitability Score",
    "createdAt": "Created At",
    "signedAllFormsAt": "Signed All Forms At",
    "completedAt": "Completed At",
    "incompleteFields": "Incomplete Fields",
    "approvedAt": "Approved At",
    "lastUpdatedBy": "Last Updated By",
    "skipIPS": "Skip IPS",
    "allowClientDeposits": "Allow Client Deposits",
    "isPartial": "Is Partial",
    "liquidated": "Liquidated",
    "tradingProcess": "Trading Process",
    "baseCurrency": "Base Currency",
    "sourceType": "Source Type",
    "custodianSuitabilityScore": "Custodian Suitability Score",
    "financialProductId": "Sub Account Financial Product ID",
    "acceptableFinancialProduct": "Acceptable Financial Product",
    "account": "Account",
    "goal": "Goal",
    "organization": "Organization",
    "theme": "Theme",
    "schedule": "Schedule",
    "financialProduct": "Financial Product",
    "feeTier": "Fee Tier",
    "applicableFeeTier": "Applicable Fee Tier",
    "billingSchedule": "Billing Schedule",
    "applicableBillingSchedule": "Applicable Billing Schedule",
    "suggestedFinancialProduct": "Suggested Financial Product",
    "statistics": "Statistics"
  },
  "goal": {
    "id": "ID",
    "name": "Name",
    "type": "Type",
    "timeHorizon": "Time Horizon",
    "expectedAnnualIncomeCents": "Expected Annual Income Cents",
    "targetAmountCents": "Target Amount Cents",
    "retirementAge": "Retirement Age",
    "targetDate": "Target Date",
    "riskQuestion1": "Risk Question 1",
    "suitabilityScore": "Suitability Score",
    "state": "State",
    "calculatedSuitabilityScore": "Calculated Suitability Score",
    "lastUpdatedBy": "Last Updated By",
    "taxOptimized": "Tax Optimized",
    "pendingAgreementSignature": "Pending Agreement Signature",
    "tradingProcess": "Trading Process",
    "timeHorizonLabel": "Time Horizon Label",
    "goalRiskQuestionLabel": "Risk Question Label",
    "createdAt": "Created At",
    "user": "User",
    "householdClientGroup": "Household",
    "organization": "Organization",
    "financialProduct": "Financial Product",
    "suggestedFinancialProduct": "Suggested Financial Product",
    "statistics": "Statistics"
  },
  "user": {
    "id": "ID",
    "stringId": "String ID",
    "availableCurrencies": "Available Currencies",
    "suitabilityScore": "Suitability Score",
    "latestNsfs": "Latest NSF",
    "state": "State",
    "title": "Title",
    "firstName": "First Name",
    "middleName": "Middle Name",
    "lastName": "Last Name",
    "primaryEmail": "Primary Email",
    "dateOfBirth": "Date Of Birth",
    "dateOfDeath": "Date Of Death",
    "phone": "Phone",
    "gender": "Gender",
    "citizenships": "Citizenships",
    "foreignTaxExists": "Foreign Tax Exists",
    "employmentStatus": "Employment Status",
    "jobTitle": "Job Title",
    "companyType": "Company Type",
    "studentAreaOfStudy": "Student Area Of Study",
    "annualIncomeCents": "Annual Income Cents",
    "annualIncomeStr": "Annual Income Str",
    "financialLiquidAssetsCents": "Financial Liquid Assets Cents",
    "financialFixedAssetsCents": "Financial Fixed Assets Cents",
    "totalDebtCents": "Total Debt Cents",
    "annualDebtPaymentsCents": "Annual Debt Payments Cents",
    "debtAssociated": "Debt Associated",
    "isOfficerOfPublicCompany": "Is Officer Of Public Company",
    "isOwnerOfPublicCompany": "Is Owner Of Public Company",
    "isMemberOfIiroc": "Is Member Of IIROC",
    "politicallyExposedForeignPerson": "Politically Exposed Foreign Person",
    "politicallyExposedDomesticPerson": "Politically Exposed Domestic Person",
    "closeAssociateOfPEP": "Close Associate Of PEP",
    "pepReason": "PEP Reason",
    "investmentKnowledge": "Investment Knowledge",
    "investmentKnowledgeLabel": "Investment Knowledge Label",
    "investmentKnowledgeDescription": "Investment Knowledge Description",
    "isAccreditedInvestor": "Is Accredited Investor",
    "riskQuestion1": "Risk Question 1",
    "riskQuestion1Label": "Risk Question 1 Label",
    "riskQuestion2": "Risk Question 2",
    "riskQuestion2Label": "Risk Question 2 Label",
    "retirementAge": "Retirement Age",
    "powerOfAttorneyGranted": "Power Of Attorney Granted",
    "language": "Language",
    "timezone": "Timezone",
    "incompleteFields": "Incomplete Fields",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "completedAt": "Completed At",
    "headOfInternationalOrganization": "Head Of International Organization",
    "maritalStatus": "Marital Status",
    "spouseTitle": "Spouse Title",
    "numberOfDependents": "Number Of Dependents",
    "spouseFirstName": "Spouse First Name",
    "spouseMiddleName": "Spouse Middle Name",
    "spouseLastName": "Spouse Last Name",
    "spouseEmail": "Spouse Email",
    "spouseEmployerName": "Spouse Employer Name",
    "spouseEmployerCompanyPhone": "Spouse Employer Company Phone",
    "spouseEmploymentStatus": "Spouse Employment Status",
    "spouseEmploymentType": "Spouse Employment Type",
    "spouseCompanyType": "Spouse Company Type",
    "spouseJobTitle": "Spouse Job Title",
    "spouseAnnualIncomeCents": "Spouse Annual Income Cents",
    "spouseAnnualIncomeStr": "Spouse Annual Income Str",
    "spouseAreaOfStudy": "Spouse Area Of Study",
    "spouseDateOfBirth": "Spouse Date Of Birth",
    "spouseTaxId": "Spouse Tax ID",
    "spouseTaxIdDisclosed": "Spouse Tax ID Disclosed",
    "spouseTaxIdType": "Spouse Tax ID Type",
    "lastUpdatedBy": "Last Updated By",
    "iDCheckCompleted": "ID Check Completed",
    "iDCheckRetrigger": "ID Check Retrigger",
    "insiderSymbols": "Insider Symbols",
    "ssSymbols": "SS Symbols",
    "complianceIssueSource": "Compliance Issue Source",
    "complianceState": "Compliance State",
    "affiliateOnly": "Affiliate Only",
    "lastSuitabilityReviewAt": "Last Suitability Review At",
    "iDVerified": "ID Verified",
    "hasCheckedPolicyAndCondition": "Has Checked Policy And Condition",
    "bulkAccountOpening": "Bulk Account Opening",
    "suitabilityReviewOverdue": "Suitability Review Overdue",
    "sinExists": "Sin Exists",
    "inProvinceSince": "In Province Since",
    "countryOfTaxResidence": "Country Of Tax Residence",
    "employerName": "Employer Name",
    "employerCompanyPhone": "Employer Company Phone",
    "employmentSituation": "Employment Situation",
    "employmentSituationOtherDescription": "Employment Situation Other Description",
    "sourceOfWealth": "Source Of Wealth",
    "sourceOfWealthOtherDescription": "Source Of Wealth Other Description",
    "sourceOfFunds": "Source Of Funds",
    "sourceOfFundsOtherDescription": "Source Of Funds Other Description",
    "uniqueCircumstances": "Unique Circumstances",
    "preferredMethodOfCommunication": "Preferred Method Of Communication",
    "preferredMethodOfCommunicationOtherDescription": "Preferred Method Of Communication Other Description",
    "readyToSignAgreement": "Ready To Sign Agreement",
    "type": "Type",
    "entityName": "Entity Name",
    "typeOfTrust": "Type Of Trust",
    "identificationType": "Identification Type",
    "registrationNumber": "Registration Number",
    "charityRegistrationNumber": "Charity Registration Number",
    "establishedDate": "Established Date",
    "countryOfRegistration": "Country Of Registration",
    "businessPhone": "Business Phone",
    "yearEnd": "Year End",
    "regulatorName": "Regulator Name",
    "firmNumber": "Firm Number",
    "issuerName": "Issuer Name",
    "issuerTicker": "Issuer Ticker",
    "issuerExchange": "Issuer Exchange",
    "parentCompanyName": "Parent Company Name",
    "isEntityRegulated": "Is Entity Regulated",
    "isReportingIssuer": "Is Reporting Issuer",
    "isRegisteredWithCRA": "Is Registered With CRA",
    "receivesDonationsFromPublic": "Receives Donations From Public",
    "isAFinancialEntity": "Is A Financial Entity",
    "isAffiliateOfFinancialEntity": "Is Affiliate Of Financial Entity",
    "instructionsFromFinancialEntity": "Instructions From Financial Entity",
    "isPublicBody": "Is Public Body",
    "isLargeCorporation": "Is Large Corporation",
    "hasGuarantor": "Has Guarantor",
    "tradingAuthorityOverAccountGranted": "Trading Authority Over Account Granted",
    "discretionOverAccountGranted": "Discretion Over Account Granted",
    "advisorInterest": "Advisor Interest",
    "advisorInterestDetail": "Advisor Interest Detail",
    "investmentFirmTrade": "Investment Firm Trade",
    "useBorrowedMoney": "Use Borrowed Money",
    "taxNumber": "Tax Number",
    "isForThirdParty": "Is For Third Party",
    "tradingAuthorityName": "Trading Authority Name",
    "investmentFirmTradeName": "Investment Firm Trade Name",
    "otherPersonGuaranteeNames": "Other Person Guarantee Names",
    "thirdPartyName": "Third Party Name",
    "isNonProfit": "Is Non Profit",
    "positionAtEntity": "Position At Entity",
    "isVulnerablePerson": "Is Vulnerable Person",
    "isOwnerOfEntity": "Is Owner Of Entity",
    "fatcaStatus": "FATCA Status",
    "fatcaStatusOtherDescription": "FATCA Status Other Description",
    "taxId": "Tax ID",
    "taxIdDisclosed": "Tax ID Disclosed",
    "taxIdType": "Tax ID Type",
    "nextSuitabilityReviewAt": "Next Suitability Review At",
    "riskScore": "Risk Score",
    "netWorthCents": "Net Worth Cents",
    "totalAssetsCents": "Total Assets Cents",
    "discretionOverAccountGrantedReason": "Discretion Over Account Granted Reason",
    "convertedFromAffiliateInvitation": "Converted From Affiliate Invitation",
    "physicalAddress": "Physical Address",
    "organization": "Organization",
    "fraudRisk": "Fraud Risk",
    "feeTier": "Fee Tier",
    "applicableFeeTier": "Applicable Fee Tier",
    "billingSchedule": "Billing Schedule",
    "applicableBillingSchedule": "Applicable Billing Schedule",
    "latestIdVerification": "Latest ID Verification",
    "trustedContactPerson": "Trusted Contact Person",
    "suggestedFinancialProduct": "Suggested Financial Product",
    "statistics": "Statistics",
    "alternateAddress": "Alternate Physical Address",
    "mailingAddress": "Mailing Address",
    "employerCompanyAddress": "Employer Company Address",
    "spouseAddress": "Spouse Address",
    "spouseEmployerCompanyAddress": "Spouse Employer Company Address"
  },
  "accountGroup": {
    "id": "ID",
    "translatedName": "Translated Name",
    "type": "Type",
    "state": "State",
    "totalAccounts": "Total Accounts",
    "lastUpdatedBy": "Last Updated By",
    "createdAt": "Created At",
    "user": "User",
    "householdClientGroup": "Household",
    "organization": "Organization",
    "statistics": "Statistics"
  },
  "clientGroup": {
    "stringId": "String ID",
    "type": "Type",
    "availableCurrencies": "Available Currencies",
    "id": "ID",
    "name": "Name",
    "state": "State",
    "completedAt": "Completed At",
    "incompleteFields": "Incomplete Fields",
    "primaryEmail": "Primary Email",
    "phone": "Phone",
    "businessIsMemberOfIiroc": "Business Is Member Of IIROC",
    "establishedDate": "Established Date",
    "corporationCountry": "Corporation Country",
    "incorporationNumber": "Incorporation Number",
    "businessType": "Business Type",
    "taxNumber": "Tax Number",
    "accountNumber": "Account Number",
    "taxNumberDisclosed": "Tax Number Disclosed",
    "createdAt": "Created At",
    "primaryUser": "Primary User",
    "organization": "Organization",
    "feeTier": "Fee Tier",
    "applicableFeeTier": "Applicable Fee Tier",
    "billingSchedule": "Billing Schedule",
    "applicableBillingSchedule": "Applicable Billing Schedule",
    "physicalAddress": "Physical Address",
    "statistics": "Statistics"
  },
  "organization": {
    "id": "ID",
    "embeddedExperienceLogoUrl": "Embedded Experience Logo URL",
    "defaultBillingSchedule": "Default Billing Schedule",
    "defaultFeeTier": "Default Fee Tier",
    "translatedName": "Translated Name",
    "subdomain": "Subdomain",
    "parent": "Parent",
    "minInvestAmountCents": "Min Invest Amount Cents",
    "minInitialDepositCents": "Min Initial Deposit Cents",
    "translatedTermsAndConditionsUrl": "Translated Terms And Conditions URL",
    "translatedSupportUrl": "Translated Support URL",
    "translatedHelpCentreUrl": "Translated Help Centre URL",
    "cashOnHoldToTradeDays": "Cash On Hold To Trade Days",
    "cashOnHoldToWithdrawDays": "Cash On Hold To Withdraw Days",
    "cancelTransferCutoffDays": "Cancel Transfer Cutoff Days",
    "defaultTradingProcess": "Default Trading Process",
    "bulkTradingProcess": "Bulk Trading Process",
    "minDepositCents": "Min Deposit Cents",
    "productShelfCurrencies": "Product Shelf Currencies",
    "customUrl": "Custom URL",
    "faviconLink": "Favicon Link",
    "browserTabTitle": "Browser Tab Title",
    "localization": "Localization",
    "applicableLocalization": "Applicable Localization",
    "profileReviewTimeInMonths": "Profile Review Time In Months",
    "repCode": "Rep Code",
    "entityName": "Entity Name",
    "minRecurringDepositCents": "Min Recurring Deposit Cents",
    "defaultAuthenticationConnection": "Default Authentication Connection",
    "multiFactorAuthenticationOptions": "Multi Factor Authentication Options",
    "baseCurrency": "Base Currency",
    "jurisdictions": "EnabledJurisdictions",
    "applicableJurisdictions": "EnabledJurisdictions"
  },
  "custodianConnection": {
    "id": "ID",
    "name": "Name",
    "moneyAccount": "Money Account",
    "inventoryAccount": "Inventory Account",
    "type": "Type",
    "repCode": "Rep Code",
    "notificationEmails": "Notification Emails",
    "default": "Default",
    "enableCustodianActivityImport": "Enable Custodian Activity Import",
    "allowTransactionCreation": "Allow Transaction Creation",
    "enableCustodianSnapshotImport": "Enable Custodian Snapshot Import",
    "enableFetchCustodianStatistics": "Enable Fetch Custodian Statistics",
    "enableFetchCustodianUpcomingTransactions": "Enable Fetch Custodian Upcoming Transactions",
    "enableFetchCustodianSuitability": "Enable Fetch Custodian Suitability",
    "enableFetchCustodianSnapshotHistory": "Enable Fetch Custodian Snapshot History",
    "enableFetchCustodianTransactions": "Enable Fetch Custodian Transactions",
    "enableFetchCustodianProjectedIncome": "Enable Fetch Custodian Projected Income",
    "enableFetchCustodianCustomFields": "Enable Fetch Custodian Custom Fields",
    "enableCustodianOrganizationImport": "Enable Custodian Organization Import",
    "enableCustodianOrganizationUserImport": "Enable Custodian Organization User Import",
    "enableAutoReconcileActivities": "Enable Auto Reconcile Activities",
    "enableAutoReconcilePositions": "Enable Auto Reconcile Positions",
    "custodianActivityImportFilePaths": "Custodian Activity Import File Paths",
    "custodianSnapshotImportFilePaths": "Custodian Snapshot Import File Paths",
    "custodianUsersImportFilePath": "Custodian Users Import File Path",
    "customerName": "Customer Name",
    "enablleTransferSubmission": "Enable Transfer Submission",
    "enableCustodianUserImport": "Enable Custodian User Import",
    "enableCustodianAccountImport": "Enable Custodian Account Import",
    "transferSubmissionType": "Transfer Submission Type",
    "accountOpeningSubmissionType": "Account Opening Submission Type",
    "enableAccountOpeningSubmission": "Enable Account Opening Submission",
    "disabledFlagTypes": "Disabled Flag Types",
    "reconciliationType": "Reconciliation Type",
    "accountTypeSettings": "Account Type Settings",
    "baseCurrency": "Base Currency",
    "allowFractionalTrading": "Allow Fractional Trading",
    "fetchLivePrices": "Fetch Live Prices",
    "enableFetchCustodianStatements": "Enable Fetch Custodian Statements",
    "enableCreateCustodianDepositTransfers": "Enable Create Custodian Deposit Transfers",
    "enableCancelCustodianDepositTransfer": "Enable Cancel Custodian Deposit Transfer",
    "enableFetchCustodianNotifications": "Enable Fetch Custodian Notifications",
    "enableChallengedCustodianDepositTransfer": "Enable Challenged Custodian Deposit Transfer",
    "enableCustodianCredentialsManager": "Enable Custodian Credentials Manager",
    "enableSaveInternalRecordsOfCustodianDepositTransfers": "Enable Save Internal Records Of Custodian Deposit Transfers",
    "allowCashAsDepositTarget": "Allow Cash As Deposit Target",
    "bulkTradeAllowedExchanges": "Bulk Trade Allowed Exchanges",
    "disableCorpInventoryAccount": "Disable Corp Inventory Account"
  },
  "enabledJurisdictions": {
    "all": "All",
    "only": "Only"
  },
  "repCode": {
    "code": "Code",
    "id": "ID",
    "name": "Name",
    "archived": "Archived",
    "state": "State"
  },
  "transactionTotal": {
    "totalCount": "Total Count",
    "totalCents": "Total Cents"
  },
  "fraudRisk": {
    "id": "ID",
    "score": "Score",
    "lastUpdatedBy": "Last Updated By",
    "notes": "Notes"
  },
  "alternatePhysicalAddress": {
    "line1": "Line 1",
    "line2": "Line 2",
    "city": "City",
    "jurisdiction": "Jurisdiction",
    "country": "Country",
    "postal": "Postal"
  },
  "alternateAddress": {
    "city": "City",
    "country": "Country",
    "jurisdiction": "Jurisdiction",
    "postal": "Postal Code",
    "line1": "Line 1",
    "line2": "Line 2"
  },
  "trustedContactPerson": {
    "name": "Name",
    "relation": "Relation",
    "email": "Email",
    "phone": "Phone",
    "physicalAddress": "Physical Address"
  },
  "idVerification": {
    "id": "ID",
    "methodOfIDVerification": "Method Of ID Verification",
    "verifiedDate": "Verified Date",
    "userName": "User Name",
    "documentType": "Document Type",
    "documentID": "Document ID",
    "documentIssuingJurisdication": "Document Issuing Jurisdication",
    "documentExpiryDate": "Document Expiry Date",
    "secondaryDocumentType": "Secondary Document Type",
    "secondaryDocumentUserName": "Secondary Document User Name",
    "secondaryDocumentID": "Secondary Document ID",
    "secondaryDocumentIssuingJurisdication": "Secondary Document Issuing Jurisdication",
    "secondaryDocumentExpiryDate": "Secondary Document Expiry Date",
    "secondaryDocumentDateOfBirth": "Secondary Document Date Of Birth",
    "secondaryDocumentVerifiedDate": "Secondary Document Verified Date",
    "state": "State",
    "creditFileSource": "Credit File Source",
    "address": "Address"
  },
  "physicalAddress": {
    "unitNumber": "Unit Number",
    "houseNumber": "House Number",
    "streetName": "Street Name",
    "neighborhood": "Neighborhood",
    "city": "City",
    "jurisdiction": "Jurisdiction",
    "country": "Country",
    "postal": "Postal"
  },
  "feeTier": {
    "id": "ID",
    "name": "Name",
    "default": "Default",
    "blendedGrid": "Blended Grid",
    "gridScopeType": "Grid Scope Type",
    "flatAnnualFeeBps": "Flat Annual Fee Bps",
    "discountPercentage": "Discount Percentage",
    "chargeForCashOnHold": "Charge For Cash On Hold",
    "chargeForCash": "Charge For Cash",
    "state": "State",
    "requestId": "Request ID",
    "type": "Type",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "extensionKey": "Extension Key",
    "resourceKey": "Resource Key",
    "extensionVersion": "Extension Version"
  },
  "billingSchedule": {
    "id": "ID",
    "default": "Default",
    "frequency": "Frequency",
    "nextBillingDate": "Next Billing Date",
    "nextCalculationDate": "Next Calculation Date",
    "startDate": "Start Date",
    "endDate": "End Date",
    "state": "State",
    "requestId": "Request ID",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "extensionKey": "Extension Key",
    "resourceKey": "Resource Key",
    "extensionVersion": "Extension Version"
  },
  "financialProduct": {
    "id": "ID",
    "stringId": "String ID",
    "priceHistoryUrl": "Price History URL",
    "name": "Name",
    "translatedName": "Translated Name",
    "state": "State",
    "suggestedMinScore": "Suggested Min Score",
    "suggestedMaxScore": "Suggested Max Score",
    "lowThresholdScore": "Low Threshold Score",
    "tradeable": "Tradeable",
    "suggestable": "Suggestible",
    "autoUpdatePrices": "Auto Update Prices",
    "assignable": "Assignable",
    "ticker": "Ticker",
    "exchange": "Exchange",
    "currency": "Currency",
    "originalCurrency": "Original Currency",
    "forecastedRateOfReturn": "Forecasted Rate Of Return",
    "forecastedStandardDeviation": "Forecasted Standard Deviation",
    "currentPriceCents": "Current Price Cents",
    "originalCurrentPriceCents": "Original Current Price Cents",
    "portfolioDescription": "Portfolio Description",
    "translatedPortfolioDescription": "Translated Portfolio Description",
    "portfolioDisclaimer": "Portfolio Disclaimer",
    "translatedPortfolioDisclaimer": "Translated Portfolio Disclaimer",
    "investmentObjective": "Investment Objective",
    "translatedInvestmentObjective": "Translated Investment Objective",
    "translatedLiquidity": "Translated Liquidity",
    "updatedAt": "Updated At",
    "riskReturnLevel": "Risk Return Level",
    "isCash": "Is Cash",
    "substituteFinancialProduct": "Substitute Financial Product",
    "isPartial": "Is Partial",
    "waivedFeePercentage": "Waived Fee Percentage",
    "taxRank": "Tax Rank",
    "settlementDays": "Settlement Days",
    "volatile": "Volatile",
    "translatedUrl": "Translated URL",
    "cusip": "CUSIP",
    "isin": "ISIN",
    "ric": "RIC",
    "exchangeMic": "Exchange MIC",
    "foreignExchangeRate": "Foreign Exchange Rate",
    "riskProfileName": "Risk Profile Name",
    "riskProfileDescription": "Risk Profile Description",
    "translatedThemeName": "Translated Theme Name",
    "strategy": "Strategy",
    "type": "Type",
    "zeroPercentCash": "Zero Percent Cash",
    "multiplier": "Multiplier",
    "cloneOf": "Clone Of",
    "fundSeries": "Fund Series",
    "theme": "Theme",
    "primaryAssetClass": "Primary Asset Class",
    "secondaryAssetClass": "Secondary Asset Class",
    "tertiaryAssetClass": "Tertiary Asset Class",
    "schedule": "Schedule",
    "portfolioTemplate": "Portfolio Template"
  },
  "theme": {
    "id": "ID",
    "name": "Name",
    "translatedName": "Translated Name",
    "description": "Description",
    "translatedDescription": "Translated Description",
    "translatedShortDescription": "Translated Short Description",
    "key": "Key",
    "core": "Core",
    "iconKey": "Icon Key",
    "state": "State"
  },
  "assetClass": {
    "id": "ID",
    "stringId": "String ID",
    "key": "Key",
    "name": "Name",
    "description": "Description",
    "translatedName": "Translated Name",
    "translatedDescription": "Translated Description",
    "state": "State",
    "includeCash": "Include Cash",
    "riskLevel": "Risk Level"
  },
  "schedule": {
    "id": "ID",
    "name": "Name",
    "dates": "Dates",
    "nextDate": "Next Date",
    "associatedFinancialProductsCount": "Associated Financial Products Count"
  },
  "portfolioTemplate": {
    "id": "ID",
    "name": "Name",
    "translatedName": "Translated Name",
    "translatedTemplateDescription": "Translated Template Description",
    "state": "State",
    "createdAt": "Created At",
    "updatedAt": "Updated At"
  },
  "statistics": {
    "stringId": "String ID",
    "currency": "Currency",
    "objectType": "Object Type",
    "forUserId": "For User ID",
    "marketValueCents": "Market Value Cents",
    "netContributionCents": "Net Contribution Cents",
    "newContributionCents": "New Contribution Cents",
    "simpleReturnAmount": "Simple Return Amount",
    "simpleReturnPercent": "Simple Return Percent",
    "timeWeightedReturn": "Time Weighted Return",
    "moneyWeightedReturn": "Money Weighted Return",
    "netContributionCentsInFiscalYear": "Net Contribution Cents In Fiscal Year",
    "id": "ID",
    "capitalGainsAndLossesInFiscalYear": "Capital Gains And Losses In Fiscal Year",
    "depositContributionCents": "Deposit Contribution Cents",
    "withdrawContributionCents": "Withdraw Contribution Cents",
    "lastUpdatedAt": "Last Updated At",
    "eodMarketValueCents": "EOD Market Value Cents",
    "moneyAvailableCents": "Money Available Cents",
    "expectedMoneyAvailableCents": "Expected Money Available Cents",
    "pendingContributionCents": "Pending Contribution Cents",
    "pendingCashCents": "Pending Cash Cents",
    "pendingWithdrawCents": "Pending Withdraw Cents",
    "availableFundsToWithdrawCents": "Available Funds To Withdraw Cents",
    "cashOnHoldToTradeCents": "Cash On Hold To Trade Cents",
    "cashOnHoldToWithdrawCents": "Cash On Hold To Withdraw Cents",
    "totalBookCostCents": "Total Book Cost Cents",
    "totalPercentage": "Total Percentage",
    "taxLossHarvestCreditInFiscalYear": "Tax Loss Harvest Credit",
    "unrealizedGainsAndLoss": "Unrealized Gains And Loss"
  },
  "taxLossHarvestCredit": {
    "id": "ID",
    "account": "Account",
    "year": "Year",
    "creditsCents": "Credits Cents"
  },
  "unrealizedGainsAndLoss": {
    "unrealizedGainsAndLossCents": "Unrealized Gains And Loss Cents",
    "unrealizedGainsAndLossCentsPercentage": "Unrealized Gains And Loss Cents Percentage"
  },
  "custodian": {
    "id": "ID",
    "name": "Name",
    "moneyAccount": "Money Account",
    "inventoryAccount": "Inventory Account",
    "type": "Type",
    "repCode": "Rep Code",
    "notificationEmails": "Notification Emails",
    "customerName": "Customer Name"
  },
  "scheduledIncomeFundTransfer": {
    "id": "ID",
    "frequency": "Frequency",
    "scheduledDate": "Scheduled Date",
    "annualAmountCents": "Annual Amount Cents",
    "amountPayableType": "Amount Payable Type",
    "dateOfBirth": "Date Of Birth",
    "minimumAnnualAmountCents": "Minimum Annual Amount Cents",
    "state": "State",
    "taxOption": "Tax Option",
    "specialTaxRate": "Special Tax Rate",
    "currency": "Currency",
    "subAccount": "SubAccount",
    "bankAccount": "Bank Account"
  },
  "bankAccount": {
    "id": "ID",
    "stringId": "String ID",
    "name": "Name",
    "institutionNumber": "Institution Number",
    "routingNumber": "Routing Number",
    "transitNumber": "Transit Number",
    "processorToken": "Processor Token",
    "bankAccountType": "Type",
    "bankAccountNumber": "Number",
    "transitNumberDisclosed": "Transit Number Disclosed",
    "bankAccountNumberDisclosed": "Number Disclosed",
    "state": "State",
    "createdAt": "Created At",
    "updatedAt": "Updated At",
    "source": "Source",
    "EftEligibleRatio": "Eft Eligible Ratio",
    "failReason": "Fail Reason",
    "fieldMatchRate": "Field Match Rate",
    "bankAccountHolderName": "Holder Name",
    "currency": "Currency",
    "downloadUrls": "Download URLs",
    "user": "User",
    "bankAccountTransitPhysicalAddress": "Bank Account Transit Physical Address"
  },
  "bankAccountTransitPhysicalAddress": {
    "houseNumber": "House Number",
    "unitNumber": "Unit Number",
    "streetName": "Street Name",
    "city": "City",
    "jurisdiction": "Jurisdiction",
    "country": "Country",
    "postal": "Postal"
  }
}
